<template>
  <div>
    <header class="header">
      <router-link to="/" exact class="home-link" v-if="windowWidth > 455">Aidan A. // Software Developer</router-link>
      <router-link to="/" exact class="home-link" v-else>Aidan A.<br>// Software Developer</router-link>
      <nav>
        <ul>
          <li><router-link to="/" exact class="link">Home</router-link></li>
          <li><router-link to="/projects" exact class="link">Projects</router-link></li>
          <!-- <li><router-link to="/contact"  exact class="link">Contact</router-link></li> -->
          <li><router-link to="/about"  exact class="link">About</router-link></li>
        </ul>
      </nav>
    </header>  
  </div>
</template>

<script>
export default {
  name: 'Header',
  data() {
    return {
      windowWidth: window.innerWidth
    }
  }
}
</script>

<style scoped>
header {
  font-family: var(--secondary-ff);
  font-weight: 400;
  font-size: var(--fs-2);
  margin-bottom: 2em;
}

nav {
  margin: 1em 0;
  padding-bottom: 0.5em;
  border-bottom: 0.13em solid var(--color-title);
}

ul {
  list-style-type: none;
  margin: 0;
  padding: 0;
  overflow: hidden;
}

li {
  display: inline-block;
  padding: 0em 2em 0em 0em;
}

.header .home-link {
  color: var(--color-title);
  transition: var(--default-transition);
}
.header .home-link:hover {
  color: var(--color-accent-1);
}
.header .home-link:active {
  color: var(--color-title);
}


a:hover {
  color: var(--color-accent-1);
}

.router-link-active {
  color: var(--color-accent-1);
}

/* Tablet S */
@media (max-width: 630px) {
  .header {
    margin-bottom: 1em;
  }

  nav {
    margin: 0.5em 0;
  }
}

/* Mobile */
@media (max-width: 450px) {
  ul {
    display: flex;
    justify-content: space-between;
  }

  .header {
    font-size: var(--fs-2m);
    margin-bottom: 1.5em;
  }
}

/* Mobile S */
@media (max-width: 330px) {
  li {
    padding: 0em;
  }
}
</style>